export const LOGIN: string = "LOGIN"